import AxiosClient from "../../../services/axios.services";

class FactorsCriteriaServices {
  getFactorCriterion = (params) =>
    AxiosClient.get(
      "/api/app/carrera_sucesion_factores_criterios/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getFactorCriterionByID = (id) =>
    AxiosClient.get(
      `/api/app/carrera_sucesion_factores_criterios/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  getFactor = (params) =>
    AxiosClient.get(
      "/api/app/carrera_sucesion_factores_criticidad/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );



  getCriteria = (params) =>
    AxiosClient.get(
      "/api/app/carrera_sucesion_criterios/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getTasks = (params) =>
    AxiosClient.get(
      "/api/app/Funcional_Funciones/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );


  editFactorCriterion = (id, data) =>
    AxiosClient.put(
      `/api/app/carrera_sucesion_factores_criterios/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveFactorCriterion = (data) =>
    AxiosClient.post(
      "/api/app/carrera_sucesion_factores_criterios/",
      data,
      {
        headers: { "Content-Type": "application/json" },

      },

    );
  deleteFactorCriterion = (id) =>
    AxiosClient.delete(
      `/api/app/carrera_sucesion_factores_criterios/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

}

export default new FactorsCriteriaServices();
